module.exports = __webpack_public_path__ + "img/hades-roulette.72bc0c87.jpg";